var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { createCustomEvent } from '../../../dom/document/createCustomEvent';
import { CommunicationsEvent } from '../communications/event';
import { CommunicationsManagerOf } from '../communications/manager';
/**
 * @inheritdoc
 */
var HTMLElementCommunicationsManager = /** @class */ (function (_super) {
    __extends(HTMLElementCommunicationsManager, _super);
    /**
     * @inheritdoc
     */
    function HTMLElementCommunicationsManager(inboundEndpoint, inboundEventType, outboundEndpoint, outboundEventType) {
        return _super.call(this, inboundEndpoint, inboundEventType, outboundEndpoint, outboundEventType) || this;
    }
    /**
     * @inheritdoc
     */
    HTMLElementCommunicationsManager.prototype.readEvent = function (e) {
        var customEvent = e;
        if (!customEvent || customEvent.type !== this.inboundEventType)
            return null;
        return customEvent.detail instanceof CommunicationsEvent
            ? customEvent.detail
            : null;
    };
    /**
     * @inheritdoc
     */
    HTMLElementCommunicationsManager.prototype.startReceiving = function (inboundEndpoint, handler) {
        inboundEndpoint.addEventListener(this.inboundEventType, handler);
    };
    /**
     * @inheritdoc
     */
    HTMLElementCommunicationsManager.prototype.stopReceiving = function (inboundEndpoint, handler) {
        inboundEndpoint.removeEventListener(this.inboundEventType, handler);
    };
    /**
     * @inheritdoc
     */
    HTMLElementCommunicationsManager.prototype.sendEvent = function (outboundEndpoint, event) {
        if (!outboundEndpoint.ownerDocument)
            return;
        var evt = createCustomEvent(outboundEndpoint.ownerDocument, this.outboundEventType, { detail: event });
        outboundEndpoint.dispatchEvent(evt);
    };
    return HTMLElementCommunicationsManager;
}(CommunicationsManagerOf));
export { HTMLElementCommunicationsManager };
//# sourceMappingURL=htmlElementManager.js.map